/* tslint:disable */
/* eslint-disable */
import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfiguration, ApiConfigurationParams } from './api-configuration';

import { MessageControllerService } from './services/message-controller.service';
import { MySvgControllerService } from './services/my-svg-controller.service';

/**
 * Module that provides all services and configuration.
 */
@NgModule({
  imports: [],
  exports: [],
  declarations: [],
  providers: [
    MessageControllerService,
    MySvgControllerService,
    ApiConfiguration
  ],
})
export class MessagingModule {
  static forRoot(params: ApiConfigurationParams): ModuleWithProviders<MessagingModule> {
    return {
      ngModule: MessagingModule,
      providers: [
        {
          provide: ApiConfiguration,
          useValue: params
        }
      ]
    }
  }

  constructor( 
    @Optional() @SkipSelf() parentModule: MessagingModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error('MessagingModule is already loaded. Import in your base AppModule only.');
    }
    if (!http) {
      throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
      'See also https://github.com/angular/angular/issues/20575');
    }
  }
}
